import { render, staticRenderFns } from "./ReversedCT.UK.2.vue?vue&type=template&id=cc73a45e&scoped=true"
import script from "./ReversedCT.UK.2.vue?vue&type=script&lang=js"
export * from "./ReversedCT.UK.2.vue?vue&type=script&lang=js"
import style0 from "./ReversedCT.UK.2.vue?vue&type=style&index=0&id=cc73a45e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc73a45e",
  null
  
)

export default component.exports